import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Field, ErrorMessage } from "formik";
import "../../assets/css/autosuggestion.css";
import { isValidArray } from "./common";
import { GlobalContext } from "../../Context/GlobalContext";
import { FormikErrorMessage } from "./fromikErrorMessage";
const AutoSuggestField = ({
  formik,
  setFieldValue,
  formValue,
  name,
  label,
  callBackFunction,
  errors,
  touched,
  innerRef,
  onKeyDown = () => {},
  required = false,
}) => {
  const globalcontext = useContext(GlobalContext);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [thisTouched, setThisTouched] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const suggestionListRef = useRef(null);
  const codeInputRef = useRef(null);
  useEffect(() => {
    if (isValidArray(globalcontext.suburbList)) {
      setSuggestions(globalcontext.suburbList);
    }
  }, [globalcontext.suburbList]);

  useEffect(() => {
    isValidArray(suggestions) && handleFilterSuggestion(formValue[name]);
  }, [suggestions]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setFieldValue(name, value);
    handleFilterSuggestion(value);
    setShowSuggestions(true);
  };

  const handleFilterSuggestion = (value) => {
    if (value) {
      const filtered = suggestions
        .filter((suggestion) => suggestion.label.toLowerCase().includes(value.toLowerCase()))
        .slice(0, 50);
      setFilteredSuggestions(filtered);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    callBackFunction(setFieldValue, suggestion);
    setShowSuggestions(false);
  };

  const autosuggestionKeyPress = (e) => {
    if (e.key == "ArrowDown" && activeSuggestion < suggestions.length - 1) {
      //setactiveSuggestion(parseInt(activeSuggestion) + 1);
      setActiveSuggestion((prev) => {
        const nextIndex = prev < filteredSuggestions.length - 1 ? prev + 1 : 0;
        scrollToActiveSuggestion(nextIndex, "down");
        return nextIndex;
      });
    } else if (e.key == "ArrowUp" && activeSuggestion > 0) {
      setActiveSuggestion((prev) => {
        const nextIndex = prev > 0 ? prev - 1 : filteredSuggestions.length - 1;
        scrollToActiveSuggestion(nextIndex, "up");
        return nextIndex;
      });
    } else if (e.key == "Enter") {
      e.preventDefault();
      if (activeSuggestion >= 0 && activeSuggestion < filteredSuggestions.length) {
        handleSuggestionClick(filteredSuggestions[activeSuggestion]);
      }
    }
    if (onKeyDown) {
      onKeyDown(e);
    }
  };

  const handleOnBlur = () => {
    setThisTouched(true);
    setTimeout(() => setShowSuggestions(false), 200);
  };

  const scrollToActiveSuggestion = (index, action) => {
    const list = suggestionListRef.current;
    if (list) {
      const item =
        index > 1
          ? action == "down"
            ? list.children[index + 2] || list.children[index + 1] || list.children[index]
            : list.children[index - 2] || list.children[index - 1] || list.children[index]
          : list.children[index];

      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };

  return (
    <Fragment>
      <Field
        id={name}
        innerRef={innerRef ?? codeInputRef}
        name={name}
        className={`form-control form-input ${thisTouched && !formValue[name] && "error-message"}`}
        type="text"
        placeholder=""
        value={formValue[name]} // Bind Formik's value
        onChange={handleInputChange}
        autoComplete="new-password"
        onBlur={handleOnBlur}
        onKeyDown={autosuggestionKeyPress}
        required={required}
      />
      <label htmlFor={name}>
        {label}
        <span className="gl-form-asterisk">*</span>
      </label>
      {showSuggestions && (
        <ul ref={suggestionListRef} className="autosuggest-suggestions">
          {isValidArray(filteredSuggestions) &&
            filteredSuggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className={index == activeSuggestion ? "active" : ""}
              >
                {suggestion.label}
              </li>
            ))}
        </ul>
      )}
      {thisTouched && !formValue[name] && <FormikErrorMessage message={"Suburb details is required"} />}
    </Fragment>
  );
};

export default AutoSuggestField;
